import styles from './Switch.module.scss';
type SwitchLaunchProps = {
    value: boolean;
    onChange: (value: boolean) => void;
};

const SwitchLaunch = ({ value, onChange }: SwitchLaunchProps) => {
    return (
        <label className={styles.switch}>
            <input
                className={styles.input}
                type="checkbox"
                checked={value}
                onChange={(e) => onChange(e.target.checked)}
            />
            <span className={styles.slider}></span>
        </label>
    );
};

export default SwitchLaunch;
